import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ApContentService } from '@ap/content';
import { ModalClosedReason, ModalOptions, ApModalService } from '@ap/modal';

import { MijnTokensBrowserAnalyticsService } from '../analytics/analytics.service';
import { LogoutModalComponent } from '../logout-modal/logout-modal.component';
import { MijnTokensBrowserNavigation } from '../mijn-tokens-browser.navigation';
import { MijnTokensBrowserService } from '../mijn-tokens-browser.service';

import content from './start.wrapper.content.json';

/**
 * @module StartWrapperModule
 * @ngdoc component
 * @name StartWrapperComponent
 */
@Component({
    selector: 'tokens-browser-start-wrapper',
    templateUrl: 'start.wrapper.component.html',
    standalone: false
})
export class StartWrapperComponent implements OnInit, OnDestroy {
    public browserName: string;
    public allowDigipas: boolean;

    private readonly subscription: Subscription = new Subscription();

    public constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly analyticsService: MijnTokensBrowserAnalyticsService,
        private readonly contentService: ApContentService,
        private readonly navigation: MijnTokensBrowserNavigation,
        private readonly mijnTokensBrowserService: MijnTokensBrowserService,
        private readonly modalService: ApModalService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.browserName = MijnTokensBrowserService.getBrowserFamily();
        this.navigation.init(this.activatedRoute.parent);
        this.analyticsService.pushAnalyticsPageview();

        this.mijnTokensBrowserService.checkDigipasAllowed().subscribe((result) => (this.allowDigipas = result));

        this.mijnTokensBrowserService.canContinueBrowserRegistration().subscribe({
            next: (isLoggedOut: boolean) => {
                if (!isLoggedOut) {
                    this.showLogoutModal();
                }
            }
        });
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public onNext(): void {
        this.mijnTokensBrowserService.setShowNotification(false);
        this.navigation.toPincode();
    }

    public onBack(): void {
        this.navigation.external(this.contentService.get('mijn.tokens.browser.start.url.back'));
    }

    private showLogoutModal(): void {
        const modalOptions: ModalOptions<any> = this.mijnTokensBrowserService.getModalOptions();
        const modalComponent = this.modalService.open(LogoutModalComponent, modalOptions);
        this.subscription.add(
            modalComponent.afterClosed().subscribe((result) => {
                if (result.reason === ModalClosedReason.ACCEPTED) {
                    this.handleModalClosedReason();
                }
            })
        );
    }

    private handleModalClosedReason(): void {
        this.mijnTokensBrowserService.terminateUserSession().subscribe({
            next: () => this.mijnTokensBrowserService.setShowNotification(true)
        });
    }
}
